import {ILogService, IQService} from "angular";
import {ApplicationService} from "../application/application.service";
import {Application} from "../model/Application";
import {AuthService} from "../auth/auth.service";
import * as _ from "lodash";
import {ApplicationId} from "../model/ApplicationId";
export interface INotification {
    key?: string;
    originator: string;
    applicationId: string;
    givenName?: string,
    familyName: string,
    created: any;
    type: string;
    link: string;
    data: any;
    seen?: boolean;
}

export class NotificationsService {

    public NOTIFICATIONS_PATH = "notifications";
    public APPLICATION_SUBSCRIBERS_PATH = "application-subscribers";
    public USER_APPLICATIONS_PATH = "user-applications";
    public USER_NOTIFICATIONS_PATH = "user-notifications";

    private refs: any[];

    /* @ngInject */
    constructor(private $log: ILogService,
                private $q: IQService,
                private authService: AuthService,
                private applicationService: ApplicationService,
                private firebase: any) {
        this.refs = [];
        this.subscribeToApplicationNotifications();
    }

    public publish(notification: INotification): ng.IPromise<string> {
        const database = this.firebase.database();

        return this.$q.all([
            this.qify(database.ref(this.NOTIFICATIONS_PATH).push(notification)),
            this.qify(database.ref(`${this.APPLICATION_SUBSCRIBERS_PATH}/${notification.applicationId}`).once("value"))
        ]).then(([notificationRef, subscribersSnapshot]) => {
            const notificationKey = notificationRef.key;

            const promises = Object.keys(subscribersSnapshot.val() || {})
                .filter((username) => username !== notification.originator) // originator shouldn't get notified
                .map((username) => database.ref(`${this.USER_NOTIFICATIONS_PATH}/${username}/${notificationKey}`).set({seen: false}))
                .map((promise) => this.qify(promise));

            return this.$q.all(promises).then(() => notificationKey);
        });
    }

    public subscribe(username: string, onUpdate: any): void {
        const database = this.firebase.database();

        const notificationRef = database.ref(`${this.USER_NOTIFICATIONS_PATH}/${username}`)
            .orderByKey()
            .limitToLast(20);

        this.refs[username] = notificationRef;

        notificationRef.on("value", (refsSnapshot) => {
            const refs = refsSnapshot.val();
            this.$q.all(
                Object.keys(refs || {}).map((key) => this.fetchNotification(key, refs[key]))
            ).then(onUpdate);
        });

        this.$log.info(`User ${username} subscribed to notifications`);
    }

    public subscribeToApplication(username: string, applicationId: string): ng.IPromise<void> {

        // this.$log.info(`Subscribing user ${username} to notifications for application ${applicationId}`);

        const database = this.firebase.database();

        const applicationToUserPath = `${this.APPLICATION_SUBSCRIBERS_PATH}/${applicationId}/${username}`;
        const userToApplicationPath = `${this.USER_APPLICATIONS_PATH}/${username}/${applicationId}`;

        return this.$q.all([
            this.qify(database.ref(applicationToUserPath).set(true)),
            this.qify(database.ref(userToApplicationPath).set(true)),
        ]).then(() => null);
    }

    public unsubscribe(username: string) {
        const notificationRef = this.refs[username];
        if (notificationRef) {
            notificationRef.off("value");
        }
    }

    public markSeen(username: string, notification: INotification): ng.IPromise<void> {
        const database = this.firebase.database();

        return this.qify(
            database.ref(`${this.USER_NOTIFICATIONS_PATH}/${username}/${notification.key}`).set({seen: true})
        );
    }

    private fetchNotification(key, value) {
        const database = this.firebase.database();

        return database.ref(`${this.NOTIFICATIONS_PATH}/${key}`)
            .once("value")
            .then((snapshot) => ({...snapshot.val(), key, seen: value.seen}))
            .then((notification) => {
                    if ( notification.familyName ) {
                       const applicantName = `${notification.givenName} ${notification.familyName}`.trim();
                        console.log("notification has applicant's names then don't fetch the application from the backend.")
                       return this.$q.resolve( {
                                ...notification,
                           applicantName: applicantName
                           }
                       )
                    } else {
                        console.log("notification doesn't have applicant's names then fetch the application from the backend.")
                        return this.applicationService.getStudentCreditApplicationById(notification.applicationId)
                            .then((application) => ({
                                ...notification,
                                applicantName: this.applicantFullName(application)
                            }))
                    }
             }
            );
    }

    /**
     * Turns a promisish thing into an angular promise
     */
    private qify(promise): ng.IPromise<any> {
        const deferred = this.$q.defer();

        promise.then(deferred.resolve).catch(deferred.reject);

        return deferred.promise;
    }

    private subscribeToApplicationNotifications() {

        this.authService.me().then((user) => {
            if (user.isStaff) {
                this.$q.all([
                    this.applicationService.getStudentCreditApplicationIds(),
                    this.applicationService.getMyAccessingApplications()
                ]).then(([applications1, applications2]) => {
                    const l = _.map(applications1, a => a.id);
                    const r = _.map(applications2, a => a.id);
                    const allApplicationIds = l.concat(r);
                    this.$log.info(`Subscribing user ${user.username} to notifications for ${allApplicationIds.length} applications`);
                    allApplicationIds.forEach((applicationId) =>
                        this.subscribeToApplication(user.username, applicationId)
                    );
                });
            }
        });
    }

    private applicantFullName(application?: Application): string {
        if (application && application.applicant) {
            return `${application.applicant.givenName} ${application.applicant.familyName}`.trim();
        }
        return "Unknown";
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/notifications/notifications.service.ts